export const getLatestAvailablePage = (
  totalElements: number,
  pageSize: number
): number => {
  if (!totalElements) {
    return 0;
  }

  const availablePagesCount = Math.ceil(totalElements / pageSize);

  const latestAvailablePage = availablePagesCount - 1;
  return latestAvailablePage;
};
